import { GuestCatalogSearchForm } from "@/components/guest-catalog/GuestCatalogSearchForm";
import { GuestCatalogTypeChips } from "@/components/guest-catalog/GuestCatalogTypeChips";
import { GuestCatalogViewToggle } from "@/components/guest-catalog/GuestCatalogViewToggle";
import type { GuestCatalogViewMode } from "@/components/guest-catalog/guestCatalogViewMode";
import type { GuestCatalogType } from "@/hooks/useGuestOpacTenantSlug";

interface GuestCatalogStickyToolbarProps {
  query: string;
  type: GuestCatalogType;
  viewMode: GuestCatalogViewMode;
  disabled: boolean;
  showViewToggle: boolean;
  onQueryChange: (value: string) => void;
  onTypeChange: (value: GuestCatalogType) => void;
  onViewModeChange: (mode: GuestCatalogViewMode) => void;
  onSubmit: (e: React.FormEvent) => void;
}

export function GuestCatalogStickyToolbar(props: GuestCatalogStickyToolbarProps) {
  return (
    <div className="sticky top-0 z-10 -mx-4 space-y-3 border-b border-gray-200/80 bg-[#F8F9FA]/95 px-4 pb-4 pt-3 backdrop-blur supports-[backdrop-filter]:bg-[#F8F9FA]/80 sm:-mx-6 sm:px-6 sm:pt-4">
      <GuestCatalogSearchForm
        query={props.query}
        disabled={props.disabled}
        onQueryChange={props.onQueryChange}
        onSubmit={props.onSubmit}
      />
      <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
        <GuestCatalogTypeChips
          value={props.type}
          disabled={props.disabled}
          onChange={props.onTypeChange}
        />
        {props.showViewToggle && (
          <GuestCatalogViewToggle
            viewMode={props.viewMode}
            onViewModeChange={props.onViewModeChange}
          />
        )}
      </div>
    </div>
  );
}
